import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 mt-10 mb-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "bg-white rounded-lg border border-gray-300 lg:w-full !overflow-x-auto" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "text-neutral-900" }
const _hoisted_7 = { class: "font-[700]" }
const _hoisted_8 = { class: "text-neutral-900" }
const _hoisted_9 = { class: "font-[700]" }
const _hoisted_10 = { class: "text-neutral-900 mt-2" }
const _hoisted_11 = { class: "font-[700]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Feedbacks escritos",
            en: "Written feedback",
          })), 1),
      _createVNode(_component_Button, {
        label: _ctx.$t('labels.generic', { pt: 'Baixar', en: 'Download' }),
        icon: "pi pi-download",
        class: "p-button-sm btn-primary h-9",
        loading: _ctx.btnLoading,
        onClick: _ctx.downloadCSV
      }, null, 8, ["label", "loading", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        slotData: _ctx.draftsFeedbacks,
        columns: _ctx.columns,
        loading: _ctx.loader,
        params: _ctx.params,
        filters: _ctx.filters,
        hasStatus: false,
        actionsTitle: _ctx.$t('labels.generic', { pt: 'Detalhes', en: 'Details' }),
        onOnGoTo: _cache[0] || (_cache[0] = (e) => _ctx.openModal(e)),
        actions: _ctx.actions,
        onOnPaginate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paginate($event)))
      }, null, 8, ["slotData", "columns", "loading", "params", "filters", "actionsTitle", "actions"])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.displayModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.displayModal) = $event)),
      header: 
        _ctx.$t('labels.generic', {
          pt: 'Nome do objetivo - ',
          en: 'Objective name - ',
        })?.concat(_ctx.currentObjective?.name ?? '')
      ,
      draggable: false,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '40vw' },
      modal: true,
      class: "custom-modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Nome: ",
                en: "Name: ",
              })), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.currentDraftFeedback.completeUserName ?? " - "), 1)
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "E-mail: ",
                en: "E-mail: ",
              })), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.currentDraftFeedback.completeUserEmail ?? " - "), 1)
          ]),
          _createElementVNode("p", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Mensagem: ",
                en: "Message: ",
              })), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.currentDraftFeedback.feedbackText ?? " - "), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}